import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const cardClasses = makeStyles<{ upcoming?: boolean }>()(({ spacing }: Theme, { upcoming }) => ({
  root: {
    marginBottom: spacing(2),
    flexDirection: 'column',
    opacity: upcoming ? 0.7 : 1,
  },
}));

export const listItemClasses = makeStyles()({
  root: {
    justifyContent: 'center',
  },
});

export const listItemIconClasses = makeStyles()(({ spacing }: Theme) => ({
  root: {
    minWidth: 'auto',
    marginRight: spacing(1.5),
  },
}));

export const listTextClasses = makeStyles<{ completed: boolean }>()(({ palette }: Theme, { completed }) => ({
  root: {
    flex: '0 1 auto',
    color: completed ? palette.success.main : palette.text.primary,
  },
}));
